import { render, staticRenderFns } from "./fade-transition.vue?vue&type=template&id=2a5f161d"
import script from "./fade-transition.vue?vue&type=script&lang=ts"
export * from "./fade-transition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5f161d')) {
      api.createRecord('2a5f161d', component.options)
    } else {
      api.reload('2a5f161d', component.options)
    }
    module.hot.accept("./fade-transition.vue?vue&type=template&id=2a5f161d", function () {
      api.rerender('2a5f161d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fade-transition/fade-transition.vue"
export default component.exports